// extracted by mini-css-extract-plugin
export default {"hostChangeContainer":"host-change-module--host-change-container--1NdE9","expandIcon":"host-change-module--expand-icon--8I7rq","tooltipIcon":"host-change-module--tooltip-icon--o9dAg"};